import React, { PropsWithChildren } from 'react'

import { Metadata } from 'next'

import { Container } from './styles'

export const metadata: Metadata = {
  robots: {
    index: false,
    follow: true,
  },
}

function RSVPPublicLayout({ children }: PropsWithChildren) {
  return <Container>{children}</Container>
}

export default RSVPPublicLayout
